export default __webpack_public_path__ + "static/media/szafy5.f6be2c9a.jpg";